import React from "react";

const BoxShadow = ({ children, style, className, method = () => { } }) => {
  return (
    <div
      style={{
        backgroundColor: "#fff",
        border: "none",
        boxShadow:
          "0 2px 0 rgb(90 97 105 / 11%), 0 4px 8px rgb(90 97 105 / 12%), 0 10px 10px rgb(90 97 105 / 6%), 0 7px 70px rgb(90 97 105 / 10%)",
        borderRadius: "0.625rem",
        overflow: "hidden",
        padding: "20px",
        ...style,
      }}
      onClick={method}
      className={className || ""}
    >
      {children}
    </div>
  );
};

export default BoxShadow;
